import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";

export const ComingSoon = () => (
  <div className="text-light flex h-32 items-center justify-center">
    <Typography.LabelMd>
      {t("admin_dashboard.analytics.coming_soon")}
    </Typography.LabelMd>
  </div>
);
